import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import billingaddressApiController from "services/billingaddress.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

const billingErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

const normalizeBillingDetail = (payload) => {
  if (Array.isArray(payload)) return payload[0] || "";
  if (payload && Array.isArray(payload.data)) return payload.data[0] || "";
  return payload || "";
};

export const BillingStoreApi = createAsyncThunk("billing/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await billingaddressApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const billingUpdateApi = createAsyncThunk("billing/update", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await billingaddressApiController
      .update(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const billingDetailApi = createAsyncThunk("billing/view", async (formValues, thunkAPI) => {
  try {
    const resposedata = await billingaddressApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "billingdetail"))
      .catch((error) => HandleError(thunkAPI, error, "billingdetail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isBillingAddressUpdates: [],
  isBillingAddressUpdatesError: "",
  isBillingAddressUpdateError: "",
  isDetailData: "",
  isDetailDataError: "",
  isApiStatus: {
    BillingStoreApi: "",
    billingUpdateApi: "",
    billingDetailApi: "",
  }
}

export const billingSlice = createSlice({
  name: "billing",
  initialState,
  reducers: {
    reset: () => initialState,

  },
  extraReducers: (builder) => {
    builder
      .addCase(BillingStoreApi.pending, (state) => {
        state.isBillingAddressUpdatesError = "";
        state.isApiStatus = { ...state.isApiStatus, BillingStoreApi: "loading" };
      })
      .addCase(BillingStoreApi.fulfilled, (state, action) => {
        if (state.isBillingAddressUpdates && state.isBillingAddressUpdates.data) {
          state.isBillingAddressUpdates.data = [action.payload, ...state.isBillingAddressUpdates.data];
        } else {
          state.isBillingAddressUpdates = { data: [action.payload] };
        }
        state.isBillingAddressUpdatesError = "";
        state.isApiStatus = { ...state.isApiStatus, BillingStoreApi: "succeeded" };
      })
      .addCase(BillingStoreApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, BillingStoreApi: "failed" };
        state.isBillingAddressUpdatesError = billingErrorMessage(action, "Unable to save billing address.");
      })
      .addCase(billingUpdateApi.pending, (state) => {
        state.isBillingAddressUpdateError = "";
        state.isApiStatus = { ...state.isApiStatus, billingUpdateApi: "loading" };
      })
      .addCase(billingUpdateApi.fulfilled, (state, action) => {
        const { id, ...changes } = action.payload;
        const existingData = state.isBillingAddressUpdates && state.isBillingAddressUpdates.data && state.isBillingAddressUpdates.data.find((event) => event.id === id);
        if (existingData) {
          Object.keys(changes).map((keyName) => {
            existingData[keyName] = changes[keyName];
          });
        }
        state.isBillingAddressUpdateError = "";
        state.isApiStatus = { ...state.isApiStatus, billingUpdateApi: "succeeded" };
      })
      .addCase(billingUpdateApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, billingUpdateApi: "failed" };
        state.isBillingAddressUpdateError = billingErrorMessage(action, "Unable to update billing address.");
      })
      .addCase(billingDetailApi.pending, (state) => {
        state.isDetailDataError = "";
        state.isApiStatus = { ...state.isApiStatus, billingDetailApi: "loading" };
      })
      .addCase(billingDetailApi.fulfilled, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, billingDetailApi: "succeeded" };
        state.isDetailData = normalizeBillingDetail(action.payload);
        state.isDetailDataError = "";
      })
      .addCase(billingDetailApi.rejected, (state, action) => {
        state.isApiStatus = { ...state.isApiStatus, billingDetailApi: "failed" };
        state.isDetailDataError = billingErrorMessage(action, "Unable to load billing details.");
      });
  },
});

export const { reset } = billingSlice.actions;
export default billingSlice.reducer;
